module.exports = __webpack_public_path__ + "static/media/download_icon_blue.e86b2cb3.svg";